// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2f2a9","modalFooterButton":"ModalNotes_modalFooterButton__27bKc"};